var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMbcicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    viewBox: "0 0 87.000000 117.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,117.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 1103 l-117 -65 0 -350 c0 -192 3 -348 8 -346 4 2 58 30 119 63 l113 60 0 353 c0 193 -1 352 -2 351 -2 0 -56 -30 -121 -66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 743 c0 -172 -4 -313 -8 -313 -5 0 -16 -6 -26 -13 -15 -11 -16 -16 -3 -47 8 -19 27 -68 41 -107 15 -40 31 -73 35 -73 4 0 56 27 117 60 60 33 113 61 118 63 4 1 -28 99 -72 217 -44 118 -101 274 -127 345 -79 214 -74 222 -75 -132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 806 c-128 -69 -160 -96 -200 -171 l-38 -70 35 -94 35 -93 20 33 c29 47 214 421 210 425 -1 1 -29 -12 -62 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 532 l-118 -237 3 -141 3 -142 118 65 117 64 0 315 c0 173 -1 314 -2 313 -2 0 -56 -107 -121 -237z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbcicon);
export default __webpack_public_path__ + "static/media/mbcicon.dccc0bcf30efae39075a67ddf1cfb887.svg";
export { ForwardRef as ReactComponent };